/**
 * Niche Configuration
 * This file is auto-generated based on the NICHE environment variable
 * Used to replace {{NICHE}} placeholders in locale files
 * 
 * Generated at: 2026-03-30T14:16:59.058Z
 */

// Niche value from environment variable (set at build time)
export const NICHE = 'trans'

export default NICHE
